import React from 'react';
import {PureAbility} from "@casl/ability";
import get from 'lodash/get';

import {buildAbilityFor} from "../configuration/permission/ability";
import {ExtendedTokenParsed} from "./AuthContext";

export const APPLICATION = 'sergencovid-web';


export interface PermissionContextInterface {
    ability: PureAbility<[string, string]>;
    update: (realm: string, roles: string[]) => void;
    updateFromToken: (token: Keycloak.KeycloakInstance) => void;
    hasPermission: (action: string, subject: string) => boolean;
}

const defaultUpdateHandler = (realm: string, roles: string[]) => {};
const defaultUpdateFromToken =  (token: Keycloak.KeycloakInstance) => {};

export const PermissionContext =
    React.createContext<PermissionContextInterface>(
        {
            ability: new PureAbility<[string, string]>(),
            update: defaultUpdateHandler,
            updateFromToken: defaultUpdateFromToken,
            hasPermission: (action: string, subject: string) => {return false}
        }
    );

export interface PermissionStoreInterface {
    ability: PureAbility<[string, string]>;
}

export const useAbility = () => {
    const abilityStore = React.useContext(PermissionContext);
    return abilityStore.ability;
}


export const usePermission = (action: string, subject: string): boolean => {
    return useAbility().can(action, subject);
};


export const collectsRoles = (application: string, token: Keycloak.KeycloakInstance): string[] => {
    let roles: string[] = (token !== undefined && token.realmAccess !== undefined ? token.realmAccess.roles : []);
    if (token && token.tokenParsed) {

        let tokenParsed: ExtendedTokenParsed = token.tokenParsed as ExtendedTokenParsed;
        if (tokenParsed.resource_access) {
            const applicationResource = get(tokenParsed.resource_access, 'application');
            const applicationRoles = applicationResource !== undefined ? get(applicationResource, 'roles') : undefined;
            if (applicationRoles !== undefined) {
                roles.push(...applicationRoles);
            }
        }
    }

    return roles;
};

export const PermissionStore: React.FC<PermissionStoreInterface> = (props) => {
    const [ability, setAbility] = React.useState(props.ability as PureAbility<[string, string]>);

    const updateHandler = (realm: string, roles: string[]) => {
        setAbility(buildAbilityFor(realm, roles).build());
    };

    const updateFromTokenHandler = (token: Keycloak.KeycloakInstance) => {
        const {realm} = token;
        const roles: string[] = collectsRoles(APPLICATION, token);

        updateHandler(realm !== undefined ? realm : '', roles);
    };

    const checkPermission = (action: string, subject: string): boolean => {
        return ability.can(action, subject);
    };

    return (
        <PermissionContext.Provider
            value={{
                ability: ability,
                update: updateHandler,
                updateFromToken: updateFromTokenHandler,
                hasPermission: checkPermission
            }}

        >
            {props.children}
        </PermissionContext.Provider>
    )
};

/*
export const hasPermission = (action: string, subject: string): boolean => {
    const abilityStore = React.useContext(PermissionContext);
    return abilityStore.ability.can(action, subject);
};
*/